import "@css/main.scss";
import "@js/bootstrap";

import { Header } from "@js/components/Header";
import { Slider } from "@js/components/Slider";
import { Archive } from "@js/components/Archive";
import { Mask } from "@js/animations/Mask";
import { Stagger } from "@js/animations/Stagger";
import { Wipe } from "@js/animations/Wipe";
import { Scroll } from "@js/animations/Scroll";
import { Translate } from "@js/animations/Translate";
import { Shape } from "@js/animations/Shape";
import { Zoom } from "@js/animations/Zoom";
import { Parallax } from "@js/animations/Parallax";
import { SplitText } from "@js/animations/SplitText";
import { SplitChar } from "@js/animations/SplitChar";
import { SplitLine } from "@js/animations/SplitLine";
import { TextOverflow } from "@js/animations/TextOverflow";
import { InfiniteScollingText } from "@js/components/InfiniteScollingText";
import { Lines } from "@js/components/Lines";
import { PageHeader } from "@js/components/PageHeader";
import { BeforeAfter } from "@js/components/BeforeAfter";
import { HeroImages } from "@js/animations/Hero/HeroImages";
import { Translation } from "@js/animations/Translation";

window.onload = () => {
  const animations = [
    HeroImages,
    Mask,
    Stagger,
    Wipe,
    Scroll,
    Translate,
    Shape,
    Zoom,
    Parallax,
    SplitText,
    SplitChar,
    SplitLine,
    TextOverflow,
    Translation
  ];

  animations.forEach((animation) => {
    new animation();
  });

  new InfiniteScollingText();
  new Header();
  new PageHeader();
  new Archive();
  new Slider();
  new Lines();
  new BeforeAfter();

  document.getElementById("back-to-top").addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  const stickyBtn = document.querySelector(".btn--sticky");
  if (stickyBtn) {
    stickyBtn.addEventListener("click", (e) => {
      const dest = new URL(stickyBtn.href, location.origin);
      if (!dest.hash) return;
      const target = document.querySelector(dest.hash);
      if (!target) return;
      if (dest.pathname.replace(/\/$/, "") !== location.pathname.replace(/\/$/, "")) return;
      e.preventDefault();
      window.lenis?.scrollTo(target, { offset: -120 });
    });
  }
};
